// Environment settings are read at runtime from /config.json, which each deployment mounts
// (Kubernetes ConfigMap), so the same build can point at any backend.
let current = {};

export async function loadRuntimeConfig() {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ""}/config.json`, {
      cache: "no-store",
    });
    if (response.ok) {
      current = await response.json();
    }
  } catch (error) {
    // Rendering continues; API calls fail until a config is available.
  }
  return current;
}

export const getRuntimeConfig = () => current;

// BACKEND selects the API the widget talks to: "loyalify" (signed session from the Shopify app
// proxy) or, by default, the old Middleware (customer from the URL, token from client credentials).
// Each deployment sets it in its config.json, so one build serves both until the switch-over.
export const isLoyalifyBackend = () => current.BACKEND === "loyalify";
